import { CurrentToken } from "app/models/user"

export enum Types {
  AUTHORIZE = "AUTHORIZATION_AUTHORIZE",
  AUTHORIZE_SUCCESS = "AUTHORIZATION_AUTHORIZE_SUCCESS",
  AUTHORIZE_FAIL = "AUTHORIZATION_FAIL",
  SET_CURRENT_USER = "AUTHORIZATION_SET_CURRENT_USER",
}

export type Action = AuthorizeAction | AuthorizeSuccessAction | AuthorizeFailAction

export type AuthorizeAction = {
  type: Types.AUTHORIZE
  payload?: { practiceId: string }
}

export type AuthorizeSuccessAction = {
  type: Types.AUTHORIZE_SUCCESS
  payload: { currentToken: CurrentToken }
}

export type AuthorizeFailAction = {
  type: Types.AUTHORIZE_FAIL
  payload: { errors: object }
}

export function authorize(practiceId?: string): AuthorizeAction {
  return {
    type: Types.AUTHORIZE,
    payload: practiceId ? { practiceId } : undefined,
  }
}

export function authorizeSuccess(currentToken: CurrentToken): AuthorizeSuccessAction {
  return {
    payload: { currentToken },
    type: Types.AUTHORIZE_SUCCESS,
  }
}

export function authorizeFail(errors: object): AuthorizeFailAction {
  return {
    payload: { errors },
    type: Types.AUTHORIZE_FAIL,
  }
}
